module.exports = __webpack_public_path__ + "178ea195d1ff67cbf30a462d7003bc21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/browser/Feature/components/claim/claim_image.jpg
// module id = 1245
// module chunks = 0